<template>
  <v-app-bar
    id="app-bar"
    absolute
    app
    color="transparent"
    flat
    height="75"
  >
    <v-btn
      class="mr-3"
      elevation="1"
      fab
      small
      @click="setDrawer(!drawer)"
    >
      <v-icon v-if="value">
        mdi-view-quilt
      </v-icon>

      <v-icon v-else>
        mdi-dots-vertical
      </v-icon>
    </v-btn>

    <v-toolbar-title
      class="hidden-sm-and-down font-weight-light"
      v-text="$route.name"
    />

    <v-spacer />

    <div class="mx-3" />

    <v-menu
      bottom
      left
      offset-y
      origin="top right"
      transition="scale-transition"
    >
      <v-list
        :tile="false"
        nav
      >
        <div>
          <app-bar-item />
        </div>
      </v-list>
    </v-menu>

    <v-btn
      v-show="isAdmin"
      class="ml-2"
      min-width="0"
      text
      to="/admin/perfil"
    >
      <v-icon>mdi-account</v-icon>
    </v-btn>

    <v-btn
      class="ml-2"
      min-width="0"
      text
      to="/logout"
    >
      <v-icon>mdi-logout</v-icon>
    </v-btn>
  </v-app-bar>
</template>

<script>
  // Components
  import { VHover, VListItem } from 'vuetify/lib'

  // Utilities
  import { mapState, mapMutations } from 'vuex'

  export default {
    name: 'DashboardCoreAppBar',

    components: {
      AppBarItem: {
        render (h) {
          return h(VHover, {
            scopedSlots: {
              default: ({ hover }) => {
                return h(VListItem, {
                  attrs: this.$attrs,
                  class: {
                    'black--text': !hover,
                    'white--text secondary elevation-12': hover,
                  },
                  props: {
                    activeClass: '',
                    dark: hover,
                    link: true,
                    ...this.$attrs,
                  },
                }, this.$slots.default)
              },
            },
          })
        },
      },
    },

    props: {
      value: {
        type: Boolean,
        default: false,
      },
    },

    data () {
      return {
        isAdmin: false,
      }
    },

    computed: {
      ...mapState(['drawer']),
      dirTo () {
        let base = null
        switch (localStorage.getItem('role')) {
          case 'ROLE_SA':
          case 'ROLE_ADMIN':
          case 'ROLE_REVIEWER':
            base = '/admin/'
            break
          case 'ROLE_USER':
            base = '/user/'
            break
        }
        return base
      },
    },

    created () {
      const role = localStorage.getItem('role')

      if (role === 'ROLE_ADMIN') {
        this.isAdmin = true
      }
    },

    methods: {
      ...mapMutations({
        setDrawer: 'SET_DRAWER',
      }),
    },
  }
</script>
